import { useTranslation } from "react-i18next";
import type { TrackType } from "@/types";

const TYPE_STYLES: Record<TrackType, string> = {
  circuit: "bg-blue-100 text-blue-800",
  gymkhana: "bg-purple-100 text-purple-800",
  drag_strip: "bg-orange-100 text-orange-800",
  hill_climb: "bg-emerald-100 text-emerald-800",
  rally: "bg-amber-100 text-amber-800",
  oval: "bg-indigo-100 text-indigo-800",
  karting: "bg-pink-100 text-pink-800",
  other: "bg-secondary-100 text-secondary-800",
};

export function TrackTypeBadge({
  type,
  className = "",
}: {
  type: TrackType;
  className?: string;
}) {
  const { t } = useTranslation("pages");
  const style = TYPE_STYLES[type] ?? TYPE_STYLES.other;
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap flex-shrink-0 ${style} ${className}`}
    >
      {t(`tracks.form.typeOptions.${type}`)}
    </span>
  );
}
